
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  AfterViewInit,
  Renderer2,
  ChangeDetectionStrategy,
  DOCUMENT
} from '@angular/core';
import { ConfigService } from 'src/app/config/config.service';
import { RightSidebarService } from 'src/app/core/service/rightsidebar.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { DirectionService } from 'src/app/core/service/direction.service';
import { InConfiguration } from 'src/app/core/models/config.interface';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FeatherIconsModule } from 'src/app/shared/components/feather-icons/feather-icons.module';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss'],
  imports: [
    NgScrollbarModule,
    MatButtonModule,
    MatTooltipModule,
    NgClass,
    TranslateModule,
    MatButtonToggleModule,
    FeatherIconsModule
  ],
})
export class RightSidebarComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {
  selectedBgColor = 'white';
  maxHeight!: string;
  maxWidth!: string;
  showpanel = false;
  isOpenSidebar!: boolean;
  isDarkSidebar = false;
  isDarTheme = false;
  public innerHeight?: number;
  headerHeight = 60;
  isRtl = false;
  public config!: InConfiguration;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private directionService: DirectionService
  ) {
    super();
  }
  ngOnInit() {
    this.config = this.configService.configData;
    this.subs.sink = this.rightSidebarService.sidebarState.subscribe(
      (isRunning) => {
        this.isOpenSidebar = isRunning;
      }
    );
    this.setRightSidebarWindowHeight();
  }

  ngAfterViewInit() {
    // set header color on startup
    if (localStorage.getItem(localStorageConstants.CHOOSE_SKIN) !== undefined && localStorage.getItem(localStorageConstants.CHOOSE_SKIN) !== null) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem(localStorageConstants.CHOOSE_SKIN) as string
      );
      this.selectedBgColor = localStorage.getItem(
        localStorageConstants.CHOOSE_SKIN_ACTIVE
      ) as string;
      if (this.selectedBgColor !== null) {
        this.selectTheme(this.selectedBgColor);
      } else {
        this.selectTheme(this.config.layout.theme_color);
      }

    } else {
      this.renderer.addClass(
        this.document.body,
        'theme-' + this.config.layout.theme_color
      );
      this.selectedBgColor = this.config.layout.theme_color;
      this.selectTheme(this.selectedBgColor);
    }

    if (localStorage.getItem(localStorageConstants.MENU_OPTION)) {
      if (localStorage.getItem(localStorageConstants.MENU_OPTION) === 'menu_dark') {
        this.isDarkSidebar = true;
      } else if (localStorage.getItem(localStorageConstants.MENU_OPTION) === 'menu_light') {
        this.isDarkSidebar = false;
      } else {
        this.isDarkSidebar =
          this.config.layout.sidebar.backgroundColor === 'dark' ? true : false;
      }
    } else {
      this.isDarkSidebar =
        this.config.layout.sidebar.backgroundColor === 'dark' ? true : false;
    }

    if (localStorage.getItem(localStorageConstants.THEME)) {
      if (localStorage.getItem(localStorageConstants.THEME) === 'dark') {
        this.isDarTheme = true;
      } else if (localStorage.getItem(localStorageConstants.THEME) === 'light') {
        this.isDarTheme = false;
      } else {
        this.isDarTheme = this.config.layout.variant === 'dark' ? true : false;
      }
    } else {
      this.isDarTheme = this.config.layout.variant === 'dark' ? true : false;
    }

    // if (localStorage.getItem(localStorageConstants.IS_RTL)) {
    //   if (localStorage.getItem(localStorageConstants.IS_RTL) === 'true') {
    //     this.setRTLSettings();
    //   } else if (localStorage.getItem(localStorageConstants.IS_RTL) === 'false') {
    //     this.setLTRSettings();
    //   }
    // } else {
    //   if (this.config.layout.rtl == true) {
    //     this.setRTLSettings();
    //   } else {
    //     this.setLTRSettings();
    //   }
    // }
  }

  selectTheme(e: string) {
    this.selectedBgColor = e;
    const prevTheme = this.elementRef.nativeElement
      .querySelector('.settingSidebar .choose-theme li.active')
      .getAttribute('data-theme');
    this.renderer.removeClass(this.document.body, 'theme-' + prevTheme);
    this.renderer.addClass(this.document.body, 'theme-' + this.selectedBgColor);
    localStorage.setItem(localStorageConstants.CHOOSE_SKIN, 'theme-' + this.selectedBgColor);
    localStorage.setItem(localStorageConstants.CHOOSE_SKIN_ACTIVE, this.selectedBgColor);
  }
  lightSidebarBtnClick() {
    this.renderer.removeClass(this.document.body, 'menu_dark');
    this.renderer.removeClass(this.document.body, 'logo-black');
    this.renderer.addClass(this.document.body, 'menu_light');
    this.renderer.addClass(this.document.body, 'logo-white');
    const menuOption = 'menu_light';
    localStorage.setItem(localStorageConstants.CHOOSE_LOGO_HEADER, 'logo-white');
    localStorage.setItem(localStorageConstants.MENU_OPTION, menuOption);
  }
  darkSidebarBtnClick() {
    this.renderer.removeClass(this.document.body, 'menu_light');
    this.renderer.removeClass(this.document.body, 'logo-white');
    this.renderer.addClass(this.document.body, 'menu_dark');
    this.renderer.addClass(this.document.body, 'logo-black');
    const menuOption = 'menu_dark';
    localStorage.setItem(localStorageConstants.CHOOSE_LOGO_HEADER, 'logo-black');
    localStorage.setItem(localStorageConstants.MENU_OPTION, menuOption);
  }
  lightThemeBtnClick() {
    this.renderer.removeClass(this.document.body, 'dark');
    this.renderer.removeClass(this.document.body, 'submenu-closed');
    this.renderer.removeClass(this.document.body, 'menu_dark');
    this.renderer.removeClass(this.document.body, 'logo-black');
    if (localStorage.getItem(localStorageConstants.CHOOSE_SKIN)) {
      this.renderer.removeClass(
        this.document.body,
        localStorage.getItem(localStorageConstants.CHOOSE_SKIN) as string
      );
    } else {
      this.renderer.removeClass(
        this.document.body,
        'theme-' + this.config.layout.theme_color
      );
    }

    this.renderer.addClass(this.document.body, 'light');
    this.renderer.addClass(this.document.body, 'submenu-closed');
    this.renderer.addClass(this.document.body, 'menu_light');
    this.renderer.addClass(this.document.body, 'logo-white');
    this.renderer.addClass(this.document.body, 'theme-white');
    const theme = 'light';
    const menuOption = 'menu_light';
    this.selectedBgColor = 'white';
    this.isDarkSidebar = false;
    localStorage.setItem(localStorageConstants.CHOOSE_LOGO_HEADER, 'logo-white');
    localStorage.setItem(localStorageConstants.CHOOSE_SKIN, 'theme-white');
    localStorage.setItem(localStorageConstants.THEME, theme);
    localStorage.setItem(localStorageConstants.MENU_OPTION, menuOption);
  }
  darkThemeBtnClick() {
    this.renderer.removeClass(this.document.body, 'light');
    this.renderer.removeClass(this.document.body, 'submenu-closed');
    this.renderer.removeClass(this.document.body, 'menu_light');
    this.renderer.removeClass(this.document.body, 'logo-white');
    if (localStorage.getItem(localStorageConstants.CHOOSE_SKIN)) {
      this.renderer.removeClass(
        this.document.body,
        localStorage.getItem(localStorageConstants.CHOOSE_SKIN) as string
      );
    } else {
      this.renderer.removeClass(
        this.document.body,
        'theme-' + this.config.layout.theme_color
      );
    }
    this.renderer.addClass(this.document.body, 'dark');
    this.renderer.addClass(this.document.body, 'submenu-closed');
    this.renderer.addClass(this.document.body, 'menu_dark');
    this.renderer.addClass(this.document.body, 'logo-black');
    this.renderer.addClass(this.document.body, 'theme-black');
    const theme = 'dark';
    const menuOption = 'menu_dark';
    this.selectedBgColor = 'black';
    this.isDarkSidebar = true;
    localStorage.setItem(localStorageConstants.CHOOSE_LOGO_HEADER, 'logo-black');
    localStorage.setItem(localStorageConstants.CHOOSE_SKIN, 'theme-black');
    localStorage.setItem(localStorageConstants.THEME, theme);
    localStorage.setItem(localStorageConstants.MENU_OPTION, menuOption);
  }
  setRightSidebarWindowHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.maxHeight = height + '';
    this.maxWidth = '500px';
  }
  onClickedOutside(event: Event) {
    const button = event.target as HTMLButtonElement;
    if (button.id !== 'settingBtn') {
      if (this.isOpenSidebar === true) {
        this.toggleRightSidebar();
      }
    }
  }
  toggleRightSidebar(): void {
    this.rightSidebarService.setRightSidebar(
      (this.isOpenSidebar = !this.isOpenSidebar)
    );
  }
  // switchDirection(event: MatSlideToggleChange) {
  //   const isrtl = String(event.checked);
  //   if (
  //     isrtl === 'false' &&
  //     document.getElementsByTagName('html')[0].hasAttribute('dir')
  //   ) {
  //     document.getElementsByTagName('html')[0].removeAttribute('dir');
  //     this.renderer.removeClass(this.document.body, 'rtl');
  //     this.directionService.updateDirection('ltr');
  //   } else if (
  //     isrtl === 'true' &&
  //     !document.getElementsByTagName('html')[0].hasAttribute('dir')
  //   ) {
  //     document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
  //     this.renderer.addClass(this.document.body, 'rtl');
  //     this.directionService.updateDirection('rtl');
  //   }
  //   localStorage.setItem(localStorageConstants.IS_RTL, isrtl);
  //   this.isRtl = event.checked;
  // }
  // setRTLSettings() {
  //   document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
  //   this.renderer.addClass(this.document.body, 'rtl');
  //   this.isRtl = true;
  //   localStorage.setItem(localStorageConstants.IS_RTL, 'true');
  // }
  // setLTRSettings() {
  //   document.getElementsByTagName('html')[0].removeAttribute('dir');
  //   this.renderer.removeClass(this.document.body, 'rtl');
  //   this.isRtl = false;
  //   localStorage.setItem(localStorageConstants.IS_RTL, 'false');
  // }
}
